import { render, staticRenderFns } from "./informationinquiry.vue?vue&type=template&id=3fffd9c9"
import script from "./informationinquiry.vue?vue&type=script&lang=js"
export * from "./informationinquiry.vue?vue&type=script&lang=js"
import style0 from "./informationinquiry.vue?vue&type=style&index=0&id=3fffd9c9&prod&lang=css"
import style1 from "./informationinquiry.vue?vue&type=style&index=1&id=3fffd9c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports